import React from "react";
import axios from "axios";
import {backendUrl} from "../../../constant";


function Adminaddteacher() {
  const [data,setData] = React.useState({

  });
  const submit = (e) => {
    e.preventDefault();
    console.log(data);
    const formData = new FormData();
    formData.append("teacherId",data.teacherId);
    formData.append("name",data.name);
    formData.append("district",data.district);
    formData.append("email",data.email);
    formData.append("password","teacher@123");
    formData.append("address",data.address);
    formData.append("city",data.city);
    formData.append("state",data.state);
    formData.append("mobile",data.mobile);
    formData.append("religion",data.religion);
    formData.append("aadharNumer",data.aadhaarNo);
    formData.append("surname",data.surname);
    formData.append("dob",data.dob);
    formData.append("fatherName",data.fatherName);
    formData.append("motherName",data.motherName);
    formData.append("gender",data.gender);
    formData.append("maritalStatus",data.maritalStatus);
    formData.append("caste",data.caste);
    formData.append("sscCertificate",data.sscCertificate);
    formData.append("appointmentLetter",data.appointmentLetter);
    formData.append("interCertificate",data.interCertificate);
    formData.append("degreeCertificate",data.degreeCertificate);
    formData.append("postDegreeCertificate",data.postDegreeCertificate);
    formData.append("trainingCertificate",data.trainingCertificate);
    formData.append("medCertificate",data.medCertificate);
    formData.append("mphilCertificate",data.mphilCertificate);
    formData.append("casteCertificate",data.casteCertificate);
    formData.append("DateOfIssue",data.DateOfIssue);
    formData.append("casteCertificateNo",data.casteCertificateNo);
    formData.append("nomineeName",data.nomineeName);
    formData.append("relation",data.relation);
    formData.append("permenantId",data.permenantId);
    formData.append("ownerEmail",localStorage.getItem("email"));
    formData.append("ownerPassword",localStorage.getItem("password"));
    formData.append("sscCourseTitle",data.sscCourseTitle);
    formData.append("sscCourseCode",data.sscCourseCode);
    formData.append("sscCourseSubject",data.sscCourseSubject);
    formData.append("sscBoardName",data.sscBoardName);
    formData.append("sscSchoolName",data.sscSchoolName);
    formData.append("sscMedium",data.sscMedium);
    formData.append("sscFirstLanguage",data.sscFirstLanguage);
    formData.append("sscPassedMonthYear",data.sscPassedMonthYear);
    formData.append("sscMarksSecured",data.sscMarksSecured);
    formData.append("sscMaximumMarks",data.sscMaximumMarks);
    formData.append("sscHallTicketNo",data.sscHallTicketNo);
    formData.append("sscPercentage",data.sscPercentage);
    formData.append("sscHallTicketNo",data.sscHallTicketNo);
    formData.append("sscCertificateNo",data.sscCertificateNo);
    formData.append("interCourseTitle",data.interCourseTitle);
    formData.append("interCourseSubject",data.interCourseSubject);
    formData.append("interBoardName",data.interBoardName);
    formData.append("interCollege",data.interCollege);
    formData.append("interMedium",data.interMedium);
    formData.append("interStream",data.interStream);
    formData.append("interPassedMonthYear",data.interPassedMonthYear);
    formData.append("interMarksSecured",data.interMarksSecured);
    formData.append("interMaxMarks",data.interMaxMarks);
    formData.append("interHallTicketNo",data.interHallTicketNo);
    formData.append("interCertificateNo",data.interCertificateNo);
    formData.append("degreeCourseTitle",data.degreeCourseTitle);
    formData.append("degreeCourseSubject",data.degreeCourseSubject);
    formData.append("degreeName",data.degreeName);
    formData.append("degreeUniversity",data.degreeUniversity);
    formData.append("degreeMedium",data.degreeMedium);
    formData.append("degreeBranch",data.degreeBranch);
    formData.append("degreePassedMonthYear",data.degreePassedMonthYear);
    formData.append("degreeMarksSecured",data.degreeMarksSecured);
    formData.append("degreeMaximumMarks",data.degreeMaximumMarks);
    formData.append("degreeHallTicketNo",data.degreeHallTicketNo);
    formData.append("degreeCertificateNo",data.degreeCertificateNo);
    formData.append("postDegreeCourseTitle",data.postDegreeCourseTitle);
    formData.append("postDegreeCourseSubject",data.postDegreeCourseSubject);
    formData.append("postDegreeName",data.postDegreeName);
    formData.append("postDegreeUniversity",data.postDegreeUniversity);
    formData.append("postDegreeMedium",data.postDegreeMedium);
    formData.append("postDegreeBranch",data.postDegreeBranch);
    formData.append("postDegreePassedMonthYear",data.ostDegreePassedMonthYear);
    formData.append("postDegreeMarksSecured",data.postDegreeMarksSecured);
    formData.append("postDegreeMaximumMarks",data.postDegreeMaximumMarks);
    formData.append("postDegreeHallTicketNo",data.postDegreeHallTicketNo);
    formData.append("postDegreeCertificateNo",data.postDegreeCertificateNo);
    formData.append("trainingCourseTitle",data.trainingCourseTitle);
    formData.append("trainingCourseSubject",data.trainingCourseSubject);
    formData.append("trainingPassedMonthYear",data.trainingPassedMonthYear);
    formData.append("trainingMarksSecured",data.trainingMarksSecured);
    formData.append("trainingMaximumMarks",data.trainingMaximumMarks);
    formData.append("trainingHallTicketNo",data.trainingHallTicketNo);
    formData.append("trainingCertificateNo",data.trainingCertificateNo);
    formData.append("medCourseTitle",data.medCourseTitle);
    formData.append("medCourseSubject",data.medCourseSubject);
    formData.append("medPassedMonthYear",data.medPassedMonthYear);
    formData.append("medMarksSecured",data.medMarksSecured);
    formData.append("medMaximumMarks",data.medMaximumMarks);
    formData.append("medHallTicketNo",data.medHallTicketNo);
    formData.append("medCertificateNo",data.medCertificateNo);
    formData.append("mphilCourseTitle",data.mphilCourseTitle);
    formData.append("mphilCourseSubject",data.mphilCourseSubject);
    formData.append("mphilPassedMonthYear",data.mphilPassedMonthYear);
    formData.append("mphilMarksSecured",data.mphilMarksSecured);
    formData.append("mphilMaximumMarks",data.mphilMaximumMarks);
    formData.append("mphilHallTicketNo",data.mphilHallTicketNo);
    formData.append("passedDepartmentalTest",data.passedDepartmentalTest);
    formData.append("noOfTests",data.noOfTests);
    formData.append("nameOfDepartmentalTest",data.nameOfDepartmentalTest);
    formData.append("regdNo",data.regdNo);
    formData.append("passedYear",data.passedYear);
    formData.append("appointingAuthority",data.appointingAuthority);
    formData.append("dateOfJoining",data.dateOfJoining);
    formData.append("school",data.school);
    formData.append("position",data.position);
    formData.append("salary",data.salary);
    
    axios({
      method: "POST",
      url: `${backendUrl}/admin/addTeacher`,
      data: formData,
      headers:{
        "Content-Type": "multipart/form-data",
      }
    }).then((res) => {
      console.log(res);
      alert("Teacher Added Successfully");
  }).catch((err) => {
      console.log(err);
  });
  }
  return (
    <>
      <div className="main-container">
        <div className="pd-ltr-20 xs-pd-20-10">
          <div className="min-height-200px">
            <div className="page-header">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <div className="title">
                    <h4>Add Teacher</h4>
                  </div>
                  <nav aria-label="breadcrumb" role="navigation">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="index.html">Home</a>
                      </li>
                      <li className="breadcrumb-item">Teacher</li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Add Teacher
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
            <div className="pd-20 card-box mb-30">
              <div className="wizard-content">
                <form className="tab-wizard wizard-circle wizard">
                  <section>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Teacher ID:</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Teacher ID"
                            onChange={(e) => {
                              setData({
                                ...data,
                                teacherId: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <h2 className="mb-20 text-blue">Personal Details </h2>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Surname :</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Surname"
                            onChange={(e) => {
                              setData({
                                ...data,
                                surname: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Name:</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Name"
                            onChange={(e) => {
                              setData({
                                ...data,
                                name: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Father Name :</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Father Name"
                            onChange={(e) => {
                              setData({
                                ...data,
                                fatherName: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Mother Name:</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Mother Name"
                            onChange={(e) => {
                              setData({
                                ...data,
                                motherName: e.target.value,
                              });
                            }}

                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Date of Birth:</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Select Date"
                            onChange={(e) => {
                              setData({
                                ...data,
                                dob: e.target.value,
                              });
                            }}

                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Gender:</label>
                          <select className="custom-select form-control" onChange={(e)=>{
                            setData({
                              ...data,
                              gender: e.target.value,
                            });
                          }}>
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Others">Others</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Caste :</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Caste Name"
                            onChange={(e) => {
                              setData({
                                ...data,
                                caste: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="form-group">
                          <label>Caste Certificate No :</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Caste Certificate No"
                            onChange={(e) => {
                              setData({
                                ...data,
                                casteCertificateNo: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Date of Issue :</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Date of Issue"
                            onChange={(e) => {
                              setData({
                                ...data,
                                DateOfIssue: e.target.value,
                              });
                            }}
                          />
                        </div>

                      <div class="form-group">
                          <label>Upload Certificate:</label>
                          <div class="custom-file ">
                            <input type="file" class="custom-file-input" onChange={(e) => {
                              setData({
                                ...data,
                                casteCertificate: e.target.files[0],
                              });
                            }} />
                            <label class="custom-file-label">Choose file</label>
                          </div>
                        </div>
                    </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Religion:</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Religion Name"
                            onChange={(e) => {
                              setData({
                                ...data,
                                religion: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Aadhaar No:</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Aadhaar Number"
                            onChange={(e) => {
                              setData({
                                ...data,
                                aadhaarNo: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Marital Status:</label>
                          <select onChange={(e)=>{
                            setData({
                              ...data,
                              maritalStatus: e.target.value,
                            });
                          }} className="custom-select form-control">
                            <option value="">Select Status</option>
                            <option value="Married">Married</option>
                            <option value="Unmarried">Unmarried</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <h2 className="mb-20 text-blue">Communication Details </h2>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Mobile:</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Mobile Number"
                            onChange={(e) => {
                              setData({
                                ...data,
                                mobile: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Email Id:</label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="abc@example.com.in"
                            onChange={(e) => {
                              setData({
                                ...data,
                                email: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Address:</label>
                          <textarea
                            className="form-control"
                            placeholder="Enter Address"
                            defaultValue={""}
                            onChange={(e) => {
                              setData({
                                ...data,
                                address: e.target.value,
                              });
                            }}
                          />
                          {/* <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Email ID"
                          /> */}
                        </div>
                      </div>
                    </div>

                    <h2 className="mb-20 text-blue">Nominee Details </h2>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Name of Nominee:</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter name"
                            onChange={(e) => {
                              setData({
                                ...data,
                                nomineeName: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Relationship with the employee:</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter the relation"
                            onChange={(e) => {
                              setData({
                                ...data,
                                relation: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Permenant Id:</label>
      
                            <input
                            type="text"
                            className="form-control"
                            placeholder="Enter permenant id"
                            onChange={(e) => {
                              setData({
                                ...data,
                                permenantId: e.target.value,
                              });
                            }}
                          />
                        
                          {/* <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Email ID"
                          /> */}
                        </div>
                      </div>

                    </div>

                    <h2 className="mb-20 text-blue">
                      Educational Qualifications{" "}
                    </h2>
                    <div className="mb-10 pd-20">
                      <h4 className="mb-20 text-blue">
                        1. SSC or Equivalent Examination
                      </h4>
                      <div className="row">
                        <div className="col-md-5 ">
                          <div className="form-group">
                            <label>Course Title: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter course title"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  sscCourseTitle: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-7 ">
                          <div className="form-group">
                            <label>Enter Course-Subject: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Course-Subject"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  sscCourseSubject: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Name of the Board : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Name of Board"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  sscBoardName: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Name of the School : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Name of School"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  sscSchoolName: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Medium : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Medium"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  sscMedium: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>First Language : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter First Language"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  sscFirstLanguage: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Passed Month/ Year : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="MM/ YYYY"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  sscPassedMonthYear: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Marks Secured : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Marks Secured"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  sscMarksSecured: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Maximum Marks : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Maximum Marks"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  sscMaximumMarks: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>HallTicket No : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter HallTicket No"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  sscHallTicketNo: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Certificate No : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Certificate No"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  sscCertificateNo: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                      <div className="col-md-12 ">
                        <div class="form-group">
                          <label>Upload Certificate:</label>
                          <div class="custom-file ">
                            <input type="file" class="custom-file-input" onChange={(e) => {
                              setData({
                                ...data,
                                sscCertificate: e.target.files[0],
                              });
                            }} />
                            <label class="custom-file-label">Choose file</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                    <div className="mb-10 pd-20">
                      <h4 className="mb-20 text-blue">
                        2. Intermediate or Equivalent Examination
                      </h4>
                      <div className="row">
                        <div className="col-md-5 ">
                          <div className="form-group">
                            <label>Course Title: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter course title"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  interCourseTitle: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-7 ">
                          <div className="form-group">
                            <label>Enter Course-Subject: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Course-Subject"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  interCourseSubject: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Name of the Board : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Name of Board"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  interBoard: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Name of the College : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Name of College"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  interCollege: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Medium : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Medium"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  interMedium: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Stream : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Stream"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  interStream: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Passed Month/ Year : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="MM/ YYYY"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  interPassedMonthYear: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Marks Secured : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Marks Secured"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  interMarksSecured: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Maximum Marks : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Maximum Marks"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  interMaxMarks: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>HallTicket No : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter HallTicket No"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  interHallTicketNo: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Certificate No : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Certificate No"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  interCertificateNo: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                      <div className="col-md-12 ">
                        <div class="form-group">
                          <label>Upload Certificate:</label>
                          <div class="custom-file ">
                            <input type="file" class="custom-file-input" onChange={(e)=>{
                              setData({
                                ...data,
                                interCertificate:e.target.files[0]
                              })
                            }} />
                            <label class="custom-file-label">Choose file</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                    <div className="mb-10 pd-20">
                      <h4 className="mb-20 text-blue">
                        3. Degree or Equivalent Examination
                      </h4>
                      <div className="row">
                        <div className="col-md-5 ">
                          <div className="form-group">
                            <label>Course Title: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter course title"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  degreeCourseTitle: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-7 ">
                          <div className="form-group">
                            <label>Enter Course-Subject: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Course-Subject"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  degreeCourseSubject: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Name of the Degree : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Name of Degree"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  degreeName: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Name of the University : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Name of University"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  degreeUniversity: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Medium : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Medium"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  degreeMedium: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Branch : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Branch"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  degreeBranch: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Passed Month/ Year : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="MM/ YYYY"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  degreePassedMonthYear: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Marks Secured : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Marks Secured"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  degreeMarksSecured: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Maximum Marks : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Maximum Marks"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  degreeMaximumMarks: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>HallTicket No : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter HallTicket No"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  degreeHallTicketNo: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Certificate No : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Certificate No"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  degreeCertificateNo: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                      <div className="col-md-12 ">
                        <div class="form-group">
                          <label>Upload Certificate:</label>
                          <div class="custom-file ">
                            <input type="file" class="custom-file-input" onChange={(e)=>{
                              setData({
                                ...data,
                                degreeCertificate:e.target.files[0]
                              })
                            }} />
                            <label class="custom-file-label">Choose file</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                    <div className="mb-10 pd-20">
                      <h4 className="mb-20 text-blue">
                        4. PostGraduate Degree or Equivalent Examination
                      </h4>
                      <div className="row">
                        <div className="col-md-5 ">
                          <div className="form-group">
                            <label>Course Title: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter course title"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  postDegreeCourseTitle: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-7 ">
                          <div className="form-group">
                            <label>Enter Course-Subject: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Course-Subject"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  postDegreeCourseSubject: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Name of the Degree : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Name of Degree"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  postDegreeName: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Name of the University : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Name of University"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  postDegreeUniversity: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Medium : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Medium"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  postDegreeMedium: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Subject : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Subject"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  postDegreeSubject: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Passed Month/ Year : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="MM/ YYYY"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  postDegreePassedMonthYear: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Marks Secured : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Marks Secured"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  postDegreeMarksSecured: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Maximum Marks : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Maximum Marks"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  postDegreeMaximumMarks: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>HallTicket No : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter HallTicket No"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  postDegreeHallTicketNo: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Certificate No : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Certificate No"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  postDegreeCertificateNo: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                      <div className="col-md-12 ">
                        <div class="form-group">
                          <label>Upload Certificate:</label>
                          <div class="custom-file ">
                            <input type="file" class="custom-file-input" onChange={(e) => {
                              setData({
                                ...data,
                                postDegreeCertificate: e.target.files[0],
                              });
                            }}/>
                            <label class="custom-file-label">Choose file</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                    <div className="mb-10 pd-20">
                      <h4 className="mb-20 text-blue">
                        5. Training Certificates
                      </h4>
                      <div className="row">
                        <div className="col-md-5 ">
                          <div className="form-group">
                            <label>Course Title: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter course title"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  trainingCourseTitle: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-7 ">
                          <div className="form-group">
                            <label>Enter Course-Subject: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Course-Subject"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  trainingCourseSubject: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Professional Graduation : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Professional Graduation"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  trainingProfessionalGraduation: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Name of the University : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Name of University"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  trainingUniversityName: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Methodology Subject 1 : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Methodology Subject 1"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  trainingMethodologySubject1: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Methodology Subject 2 : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Methodology Subject 2"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  trainingMethodologySubject2: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-4 ">
                          <div className="form-group">
                            <label>Passed Month/ Year : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="MM/ YYYY"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  trainingPassedMonthYear: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Marks Secured : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Marks Secured"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  trainingMarksSecured: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Maximum Marks : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Maximum Marks"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  trainingMaximumMarks: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>HallTicket No : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter HallTicket No"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  trainingHallTicketNo: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Certificate No : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Certificate No"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  trainingCertificateNo: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                      <div className="col-md-12 ">
                        <div class="form-group">
                          <label>Upload Certificate:</label>
                          <div class="custom-file ">
                            <input type="file" class="custom-file-input" onChange={(e)=>{
                              setData({
                                ...data,
                                trainingCertificate:e.target.files[0]
                              })
                            }}/>
                            <label class="custom-file-label">Choose file</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                    <div className="mb-10 pd-20">
                      <h4 className="mb-20 text-blue">
                        6. M.Ed/ M.P.ED or Equivalent Examination
                      </h4>
                      <div className="row">
                        <div className="col-md-5 ">
                          <div className="form-group">
                            <label>Course Title: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter course title"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  medCourseTitle: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-7 ">
                          <div className="form-group">
                            <label>Enter Course-Subject: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Course-Subject"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  medCourseSubject: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Professional Qualification : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Professional Qualification"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  medProfessionalQualification: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Name of the University : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Name of University"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  medUniversityName: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Passed Month/ Year : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="MM/ YYYY"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  medPassedMonthYear: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Marks Secured : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Marks Secured"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  medMarksSecured: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Maximum Marks : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Maximum Marks"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  medMaximumMarks: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>HallTicket No : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter HallTicket No"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  medHallTicketNo: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                      <div className="col-md-12 ">
                        <div class="form-group">
                          <label>Upload Certificate:</label>
                          <div class="custom-file ">
                            <input type="file" class="custom-file-input" onChange={(e)=>{
                              setData({
                                ...data,
                                medCertificate:e.target.files[0]
                              })
                            }}/>
                            <label class="custom-file-label">Choose file</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                    <div className="mb-10 pd-20">
                      <h4 className="mb-20 text-blue">
                        7. M.Phil/ P.HD or Equivalent Examination
                      </h4>
                      <div className="row">
                        <div className="col-md-5 ">
                          <div className="form-group">
                            <label>Course Title: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter course title"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  mphilCourseTitle: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-7 ">
                          <div className="form-group">
                            <label>Enter Course-Subject: </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Course-Subject"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  mphilCourseSubject: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Professional Qualification : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Professional Qualification"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  mphilProfessionalQualification: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 ">
                          <div className="form-group">
                            <label>Name of the University : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Name of University"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  mphilUniversityName: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Passed Month/ Year : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="MM/ YYYY"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  mphilPassedMonthYear: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Marks Secured : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Marks Secured"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  mphilMarksSecured: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>Maximum Marks : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Maximum Marks"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  mphilMaximumMarks: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-3 ">
                          <div className="form-group">
                            <label>HallTicket No : </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter HallTicket No"
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  mphilHallTicketNo: e.target.value,
                                });
                              }}

                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                      <div className="col-md-12">
                        <div class="form-group">
                          <label>Upload Certificate:</label>
                          <div class="custom-file ">
                            <input type="file" class="custom-file-input" onChange={(e)=>{
                              setData({
                                ...data,
                                mphilCertificate:e.target.files[0]
                              })
                            }}/>
                            <label class="custom-file-label">Choose file</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                    <h2 className="mb-20 text-blue">Departmental Test Details</h2>
                    <div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Passed any Departmental Test?(Yes/ No)</label>
                            <select className="custom-select form-control" onChange={(e)=>{
                              setData({
                                ...data,
                                passedDepartmentalTest:e.target.value
                              })
                            }}>
                            <option value="">Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                          </div>
                          
                        </div>
                        <div className="col-md-6">
                        <div className="form-group">
                          <label>No. of Tests :</label>
                          <input
                            type="number"
                            min = {'0'}
                            className="form-control"
                            placeholder="Enter no. of tests"
                            onChange={(e)=>{
                              setData({
                                ...data,
                                noOfTests:e.target.value
                              })
                            }}
                          />
                        </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Name of the Departmental Test Passed : </label>
                            <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Name of the test"
                            onChange={(e)=>{
                              setData({
                                ...data,
                                nameOfDepartmentalTest:e.target.value
                              })
                            }}
                          />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Regd.No : </label>
                            <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Regd.no"
                            onChange={(e)=>{
                              setData({
                                ...data,
                                regdNo:e.target.value
                              })
                            }}
                          />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Passed Year : </label>
                            <input
                            type="text"
                            className="form-control"
                            placeholder="MM/YYYY"
                            onChange={(e)=>{
                              setData({
                                ...data,
                                passedYear:e.target.value
                              })
                            }}
                          />
                          </div>
                        </div>
                      </div>
                    </div>
                          
                    <div className="mb-20">
                    <h2 className="mb-20 text-blue">Details of First Appointment </h2>

                    <div className="row">
                      <div className="col-md-6">
                      <div className="form-group">
                          <label>Appointing Authority :</label>
                          <select className="custom-select form-control" onChange={(e)=>{
                              setData({
                                ...data,
                                appointingAuthority:e.target.value
                              })
                            }}>
                            <option value="">Select Authority</option>
                            <option value="DEO">DEO</option>
                            <option value="MEO">MEO</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                      <div className="form-group">
                          <label>Date of Joining:</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Select Date"
                            onChange={(e)=>{
                              setData({
                                ...data,
                                dateOfJoining:e.target.value
                              })
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>State :</label>
                          <select className="custom-select form-control" onChange={(e)=>{
                              setData({
                                ...data,
                                state:e.target.value
                              })
                            }}>
                            <option value="">Select State</option>
                            <option value="Maharashtra">Maharashtra</option>
                            <option value="Telangana">Telangana</option>
                            <option value="Andhra Pradesh">Andhra Pradesh</option>
                            <option value="Karnataka">Karnataka</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>District :</label>
                          <select className="custom-select form-control" onChange={
                            (e)=>{
                              setData({
                                ...data,
                                district:e.target.value
                              })
                            }
                          }
                          > 
                            <option value="">Select District</option>
                            <option value="Nagpur">Nagpur</option>
                            <option value="Thane">Thane</option>
                            <option value="Nashik">Nashik</option>
                            <option value="Kolhapur">Kolhapur</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>School :</label>
                          <select className="custom-select form-control" onChange={(e)=>{
                            setData({
                              ...data,
                              school:e.target.value
                            })
                          }}>
                            <option value="">Select School</option>
                            <option value="ZPHSP">ZPHS, Pune</option>
                            <option value="ZPHST">ZPHS, Thane</option>
                            <option value="ZPHSN">ZPHS, Nashik</option>
                            <option value="ZPHSND">ZPHS, Nanded</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Position :</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Position"
                            onChange={(e)=>{
                              setData({
                                ...data,
                                position:e.target.value
                              })
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Salary :</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Salary"
                            onChange={(e)=>{
                              setData({
                                ...data,
                                salary:e.target.value
                              })
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 ">
                        <div class="form-group">
                          <label>Upload Appointment Letter:</label>
                          <div class="custom-file ">
                            <input type="file" class="custom-file-input" onChange={(e)=>{
                              setData((pre)=>({
                                ...pre,
                                appointmentLetter:e.target.files[0]
                              }))
                            }} />
                            <label class="custom-file-label">Choose file</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                    <div className="form-group row">
                      <label className="col-sm-12 col-md-12 col-form-label"></label>
                      <div className="col-sm-12 col-md-10">
                        <input
                          className="btn btn-primary"
                          type="submit"
                          defaultValue="Submit"
                          onClick={submit}
                        />
                      </div>
                    </div>
                  </section>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Adminaddteacher;
// your code goes here